const AttachmentIcons = () => {
	return (
		<svg
			className="icons-gray"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="#6F767E"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M18.6997 7.61397C17.5282 6.44239 15.6287 6.44239 14.4571 7.61397L8.80025 13.2708C8.40972 13.6613 8.40972 14.2945 8.80025 14.685C9.19077 15.0756 9.82394 15.0756 10.2145 14.685L15.8713 9.02818C16.2618 8.63765 16.895 8.63765 17.2855 9.02818C17.6761 9.4187 17.6761 10.0519 17.2855 10.4424L11.6287 16.0992C10.4571 17.2708 8.55761 17.2708 7.38603 16.0992C6.21446 14.9277 6.21446 13.0282 7.38603 11.8566L13.0429 6.19975C14.9955 4.24713 18.1613 4.24713 20.114 6.19975C22.0666 8.15237 22.0666 11.3182 20.114 13.2708L14.4571 18.9277C11.7234 21.6613 7.29128 21.6613 4.55761 18.9277C1.82394 16.194 1.82394 11.7618 4.55761 9.02818L10.2145 3.37132C10.605 2.9808 11.2381 2.9808 11.6287 3.37132C12.0192 3.76185 12.0192 4.39501 11.6287 4.78554L5.97182 10.4424C4.0192 12.395 4.0192 15.5608 5.97182 17.5135C7.92444 19.4661 11.0903 19.4661 13.0429 17.5135L18.6997 11.8566C19.8713 10.685 19.8713 8.78554 18.6997 7.61397Z"
				fill="#33383F"
			/>
		</svg>
	);
};
export default AttachmentIcons;
